<template>
  <div class="newsletter">
    <transition name="fade" mode="in-out">
      <div
        :key="currentIndex"
        class="newsletter__bg"
        :style="`background-image: url('${currentImg}')`"
      ></div>
    </transition>
    <div class="newsletter__content">
      <div class="container">
        <h2>Something better is coming!</h2>
        <p>
          With Upmood Team’s continued research and effort to improve <br />
          emotional awareness, new and improved emotion-tracking device is
          waiting for you!
        </p>
        <a @click="toggleSubscribeNow">LEARN MORE</a>
      </div>
    </div>
    <transition name="slide-up">
      <subscribe-now v-show="showSubscribeNow" :currentImg="currentImg" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SubscribeNow from "@/components/NewsletterSubscribeNow";

export default {
  data() {
    return {
      images: ["upmoodwatch1.png", "upmoodwatch2.png"],
      timer: null,
      currentIndex: 0
    };
  },

  computed: {
    ...mapGetters({
      showSubscribeNow: "newsletter/showSubscribeNow"
    }),

    currentImg() {
      const img = this.images[this.currentIndex];
      return require(`@/assets/img/${img}`);
    }
  },

  mounted() {
    this.startSlide();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    toggleSubscribeNow() {
      this.$store.dispatch("newsletter/toggleSubscribeNow", true);
    },

    startSlide() {
      this.timer = setInterval(() => {
        if (this.currentIndex < this.images.length - 1) this.currentIndex += 1;
        else this.currentIndex = 0;
      }, 8000);
    }
  },

  components: {
    "subscribe-now": SubscribeNow
  }
};
</script>

<style lang="scss" scoped>
.newsletter {
  color: #fff;
  position: relative;
  z-index: 99;
  font-family: Lato, sans-serif;

  .newsletter__bg,
  .newsletter__content {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .newsletter__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
  }

  .newsletter__content {
    background-color: #00000040;
    position: relative;
    padding: 10px;
    line-height: 24px;
    padding: 50px 0;

    h3 {
      font-weight: 400;
    }

    p {
      margin: 20px 0;
    }

    a {
      text-decoration: none;
      cursor: pointer;
      padding-bottom: 10px;
      border-bottom: 1px solid #fff;

      @include desktop {
        border-bottom: 1px solid transparent;
        transition: 0.3s;

        &:hover {
          border-color: #fff;
        }
      }
    }
  }
}
</style>
